// ##############################
// // // Tasks for TasksCard - see Dashboard view
// #############################

var devices = [
  "device outages on third floor",
  "malfunction on tenth floor - vav3 - no heat",
  "Archives ltd. client complaint abt temp",
];
var app = [
  "issues viewing date on overview page - mobile",
  "log doesn't enter on signup page"
];
var client = [
  "floor three room two client billing issue",
  "new client in building - transfer app over",
  "request from Imports-Exports ltd. for legacy data"
];

module.exports = {
  // these 3 are used to create the tasks lists in TasksCard - Dashboard view
  devices,
  app,
  client
};



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/dashboard_tabs/variables/general.jsx